import AgenticAI from "@/components/agenticAI";

const AgenticAIPage = () => <AgenticAI />;

export default AgenticAIPage;
